import React from 'react';

import { GuideCopyAction, GuideMarkdown } from '@backrs_ui/grow-ui/src/components/GuidePage';

import { Box, SxProps, Theme } from '@mui/material';

type EmailTemplateCardProps = Readonly<{
  id: string;
  paragraphs: readonly string[];
  /** Plain-text version of the template placed on the clipboard by the copy action. */
  copyText: string;
}>;

export const EmailTemplateCard: React.FC<EmailTemplateCardProps> = ({
  id,
  paragraphs,
  copyText,
}) => (
  <Box id={id} sx={cardSx}>
    {paragraphs.map((paragraph) => (
      <GuideMarkdown key={paragraph}>{paragraph}</GuideMarkdown>
    ))}
    <Box sx={actionsSx}>
      <GuideCopyAction id={`${id}-copy-btn`} text={copyText} />
    </Box>
  </Box>
);

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
  p: backrs.spacing['spacing-2xl'],
  borderRadius: backrs.radius['radius-xl'],
  border: `1px dashed ${backrs.colors['Colors/Foreground/fg-quinary']}`,
  backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
});

const actionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
};
